// extracted by mini-css-extract-plugin
export default {"link":"arrow-button_link__L7OV4","text":"arrow-button_text__qtOcp","arrows":"arrow-button_arrows__1dUWS","left":"arrow-button_left__3WmYl","arrow":"arrow-button_arrow__VaU9l"};